import { RowScheduleModel } from 'countable@model';

export class GroupScheduleModel{
  groupLinkId: number = null;
  name: string = null;
  submoduleId: number = null;
  rows: RowScheduleModel[] = [];
}
